var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"sticky-container"},[_c('div',{class:['positioning-container', {bounce: !!_vm.component}]},[_c('Transition',{attrs:{"name":_vm.appearAndDisappearTransitionName}},[_c(_vm.component,_vm._b({tag:"component"},'component',_vm.componentProps,false))],1)],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }